import { render } from "./housereview.vue?vue&type=template&id=0f4f64a5&scoped=true"
import script from "./housereview.vue?vue&type=script&lang=js"
export * from "./housereview.vue?vue&type=script&lang=js"

import "./housereview.vue?vue&type=style&index=0&id=0f4f64a5&scoped=true&lang=css"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4f64a5"]])

export default __exports__